/* eslint-disable no-await-in-loop */
/* eslint-disable no-unused-vars */
/* eslint-disable vars-on-top */
/* eslint-disable prefer-destructuring */
/* eslint-disable prefer-const */
/* eslint-disable react/require-default-props */
/* eslint-disable react/forbid-prop-types */
/* eslint-disable max-len */
/* eslint-disable no-redeclare */
/* eslint-disable no-use-before-define */
/* eslint-disable react/prop-types */
/* eslint-disable no-var */
/* eslint-disable no-const-assign */
/* eslint-disable react/jsx-no-bind */
/* eslint-disable func-names */
/* eslint-disable no-unused-expressions */
/* eslint-disable no-undef */
/* eslint-disable no-restricted-syntax */
/* eslint-disable guard-for-in */
/* eslint-disable react/no-unused-state */
/* eslint-disable react/destructuring-assignment */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core';
import Stepper from '@material-ui/core/Stepper';
import Step from '@material-ui/core/Step';
import StepLabel from '@material-ui/core/StepLabel';
import Button from '@material-ui/core/Button';
import Lock from '@material-ui/icons/Lock';
import Avatar from '@material-ui/core/Avatar';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import CircularProgress from '@material-ui/core/CircularProgress';
import red from '@material-ui/core/colors/red';
import { Query } from 'react-apollo';
import {
  curry,
  compose,
  contains,
  pathOr,
  prop,
  isEmpty,
  find,
} from 'ramda';
import { components as commonComponents } from '@555platform/portal-components/lib/client';
import uuidv4 from 'uuid/v4';
import CopyRoleHeader from './CopyRoleHeader';
import { RolesContainer, GET_ROLE } from './RolesContainer';

var selectedTeams = CopyRoleHeader.selectedTeams;

const ERROR_MESSAGE_TTL_MS = 5000;

var team = '';

const styles = theme => ({
  backButton: {
    marginRight: theme.spacing.unit,
    fontSize: '14px',
  },
  backButtonHidden: {
    display: 'none',
    marginRight: theme.spacing.unit,
    fontSize: '14px',
  },
  instructions: {
    marginTop: theme.spacing.unit,
    marginBottom: theme.spacing.unit,
  },
  button: {
    fontSize: '14px',
    color: '#FFFFFF',
  },
  card: {
    minWidth: 275,
    overflow: 'visible',
  },
  buttons: {
    marginTop: '1rem',
  },
  buttonProgress: {
    color: red[500],
    position: 'absolute',
    top: '50%',
    left: '50%',
    marginTop: -12,
    marginLeft: -12,
  },
  error: {
    width: '100%',
    textAlign: 'center',
    color: '#b61402',
    animation: `inOut ${ERROR_MESSAGE_TTL_MS / 1000}s linear`,
  },
  '@keyframes inOut': {
    '0%': {
      height: '0em',
      opacity: '0',
    },
    '4%': {
      height: '1em',
      opacity: '1',
    },
    '96%': {
      height: '1em',
      opacity: '1',
    },
    '100%': {
      height: '0em',
      opacity: '0',
    },
  },
});

const getSteps = () => ['Select teams', 'Select Permissions'];

const dataOr = (defaultValue, dataPath, data) => (isEmpty(data)
  ? defaultValue
  : path(dataPath, data)
);

const findPermission = (resource, action) => find(allPass([propEq('action', action), propEq('resource', resource)]));
const isActionEnabled = (action, permissions) => (isNil(permissions)
  ? ({ enabled: false, ...action })
  : ({ enabled: true, ...action })
);

const isDuplicateKeyError = compose(
  contains('E11000 duplicate key error collection'),
  pathOr('', ['message']),
);

class SelectTeams extends Component {
    state = {
      activeStep: 0,
      displayName: this.props.location.state.displayName,
      team: '',
      name: '',
      creatingRole: false,
      error: null,
      permissions: this.props.location.state.permissions,
    };

  onPermissionChange = curry((handlers, roleIdentifier, resource, action, isEnabled) => {
    const { allowFn, removeFn } = handlers;
    return isEnabled
      ? allowFn({ variables: { action, resource, roleIdentifier } })
      : removeFn({ variables: { action, resource, roleIdentifier } });
  });

  handleBack = () => {
    this.setState(state => ({
      activeStep: state.activeStep - 1,
    }));
  };

  handleNext = async (handler) => {
    var { permissions } = this.props.location.state;
    var { displayName } = this.props.location.state;
    this.setState({ team });

    this.setState({ creatingRole: true });

    if (displayName === '' || team === '') {
      this.setState({
        error: new Error('Both name and team values are required'),
        creatingRole: false,
      });
      return;
    }

    const newName = uuidv4();

    const roleIdentifier = {
      name: newName,
      displayName,
      team,
    };
    permissions = { permissions };

    try {
      await handler({ variables: { roleIdentifier, permissions } });
    } catch (err) {
      if (isDuplicateKeyError(err)) {
        this.setState({ error: new Error('Role with this name already exists') });
      } else {
        this.setState({ error: new Error('Could not create new role, try again later') });
      }

      this.setState({ creatingRole: false });
      return;
    }

    this.setState({
      activeStep: 1,
      creatingRole: false,
      name: newName,
    });
  };

  getStepContent = () => {
    const {
      team, name, activeStep,
    } = this.state;
    const { displayName } = this.props.location.state;
    const { permissions } = this.props.location.state;
    switch (activeStep) {
      case 0:
        return (
          <CopyRoleHeader
            name={displayName}
            team={team}
            permissions={permissions}
            readOnly={false}
            onChange={this.onHeaderChange}
          />
        );
      case 1:
        return (
          <Query
            query={GET_ROLE}
            notifyOnNetworkStatusChange
            variables={{ name, team }}
            context={{ useLocalError: true }}
          >
            {() => (
              <RolesContainer roleID={name} teamID={team}>
                {({ allow, removePermission }) => {
                  this.setState({ creatingRole: true });
                  for (var x in permissions) {
                    var { resource } = permissions[x];
                    var { action } = permissions[x];
                    var isEnabled = permissions[x].allowed;
                    this.onPermissionChange({
                      allowFn: allow.mutation,
                      removeFn: removePermission.mutation,
                    }, {
                      name,
                      team,
                      displayName,
                    },
                    resource,
                    action,
                    isEnabled);
                  }
                  this.setState({ activeStep: 0 });
                  return null;
                }}
              </RolesContainer>
            )}
          </Query>
        );
      default:
        return 'Uknown stepIndex';
    }
  };

  render() {
    const { classes, history } = this.props;
    const steps = getSteps();
    const { creatingRole, error, activeStep } = this.state;

    if (error) {
      setTimeout(() => this.setState({ error: null }), ERROR_MESSAGE_TTL_MS + 50);
    }

    return (
      <RolesContainer>
        {({ allow, removePermission, createEmptyRole }) => (
          <commonComponents.Panel
            title="Select Teams"
            avatar={(
              <Avatar>
                <Lock />
              </Avatar>
            )}
          >
            <div>
              {error && <div className={classes.error}>{prop('message', error)}</div>}
              <Stepper activeStep={activeStep} alternativeLabel>
                {steps.map(label => (
                  <Step key={label}>
                    <StepLabel>{label}</StepLabel>
                  </Step>
                ))}
              </Stepper>
              <div>
                <Card className={classes.card}>
                  <CardContent>{this.getStepContent()}</CardContent>
                </Card>
                <div className={classes.buttons}>
                  <Button
                    onClick={activeStep === 0 ? () => history.go(-2) : this.handleBack}
                    className={activeStep === 0 ? classes.backButton : classes.backButtonHidden}
                  >
                    {activeStep === 0 ? 'Back to Role List' : 'Back'}
                  </Button>
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={async () => {
                      while (selectedTeams.length > 0) {
                        var item = selectedTeams.pop();
                        team = item.id;
                        while (item.checked === false) {
                          item = selectedTeams.pop();
                          team = item.id;
                        }
                        if (item.checked) {
                          await this.handleNext(createEmptyRole.mutation);
                          await this.setState({ activeStep: 1 });
                        }
                      }
                    }
                  }
                    className={classes.button}
                    disabled={creatingRole}
                  >
                    {'Next'}
                    {creatingRole && (
                      <CircularProgress size={24} className={classes.buttonProgress} />
                    )}
                  </Button>
                </div>
              </div>
            </div>
          </commonComponents.Panel>
        )}
      </RolesContainer>
    );
  }
}

SelectTeams.propTypes = {
  classes: PropTypes.object,
};

export default withStyles(styles)(SelectTeams);
